import axios, { AxiosRequestConfig } from 'axios'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'

const axiosConfiguration: AxiosRequestConfig = {
  headers: {}
}

const externalServices = axios.create(axiosConfiguration)

externalServices.interceptors.request.use(
  (config) => {
    const source = axios.CancelToken.source()
    store.dispatch(`${ModuleNamespaces.AUTH}/addPendingRequest`, source)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default externalServices
